import { Gavel } from 'lucide-react';

import { defineTour, type TourResolver } from '@nucleus-commerce/admin-kit/tour';
import { getAdminV1StoresStoreIdAuctions } from '@nucleus-commerce/api-client/admin';

/** A live auction shows the most of the page (countdown, leader, End now); else the newest one. */
const auctionForDetail: TourResolver = {
  key: 'auction-for-detail',
  thing: 'things.auction',
  load: async ({ storeId }) => {
    if (!storeId) return null;
    const live = await getAdminV1StoresStoreIdAuctions({ storeId }, { limit: 1, status: 'live' });
    const auction =
      live.items[0] ?? (await getAdminV1StoresStoreIdAuctions({ storeId }, { limit: 1 })).items[0];
    return auction ? { storeId, auctionId: auction.id } : null;
  },
};

export const auctionsListTour = defineTour({
  id: 'auctions.list',
  version: 1,
  group: 'orders',
  route: '/_authed/_active/s/$storeId/auctions/',
  scope: 'store',
  requires: 'auctions.read',
  icon: Gavel,
  steps: [
    { id: 'tabs', kind: 'explain', target: 'auctions.list.tabs' },
    {
      id: 'list',
      kind: 'explain',
      variants: [
        { target: 'auctions.list.table' },
        { target: 'auctions.list.empty', copy: 'empty' },
      ],
    },
    { id: 'new', kind: 'action', target: 'auctions.list.new', requires: 'auctions.write' },
    {
      id: 'starting-price',
      kind: 'explain',
      target: 'auctions.form.starting-price',
      requires: 'auctions.write',
      optional: true,
      waitMs: 1500,
    },
    { id: 'bidders', kind: 'explain', target: 'auctions.list.bidders' },
  ],
  related: ['auctions.detail', 'orders.list'],
});

export const auctionDetailTour = defineTour({
  id: 'auctions.detail',
  version: 1,
  group: 'orders',
  route: '/_authed/_active/s/$storeId/auctions/$auctionId',
  scope: 'record',
  resolve: auctionForDetail,
  requires: 'auctions.read',
  icon: Gavel,
  steps: [
    { id: 'summary', kind: 'explain', target: 'auctions.detail.summary' },
    { id: 'bids', kind: 'explain', target: 'auctions.detail.bids', placement: 'right' },
    {
      id: 'outcome',
      kind: 'explain',
      target: 'auctions.detail.outcome',
      placement: 'left',
      optional: true,
    },
    { id: 'settings', kind: 'explain', target: 'auctions.detail.settings', placement: 'left' },
    {
      id: 'end',
      kind: 'explain',
      target: 'auctions.detail.end',
      requires: 'auctions.write',
      optional: true,
      waitMs: 1000,
    },
  ],
  related: ['auctions.list', 'orders.detail'],
});
